import type { IResourceItem } from '@refinedev/core';
import {
  BellSideBarIcon,
  ConsumerIcon,
  DashboardIcon,
  OrderIcon,
} from '../Assets/Svgs';

export const resources: IResourceItem[] = [
  {
    name: 'dashboard',
    list: '/',
    meta: {
      icon: <DashboardIcon />,
    },
  },
  {
    name: 'account-cruds',
    list: '/consumer-list',
    show: '/consumer-list/show/:id',
    meta: {
      canCreate: true,
      canEdit: false,
      canDelete: false,
      canShow: true,
      icon: <ConsumerIcon />,
    },
  },
  {
    name: 'notification-cruds',
    list: '/notification-management',
    meta: {
      canCreate: true,
      canEdit: false,
      canDelete: false,
      canShow: true,
      icon: <BellSideBarIcon />,
    },
  },
  {
    name: 'contact-us',
    list: '/contact-us',
    meta: {
      canCreate: true,
      canEdit: false,
      canDelete: false,
      canShow: true,
      icon: <OrderIcon />,
    },
  },
];
